<!-- 要素匹配 -->
<template>
  <div>
    <li v-for="item in conditionSettings">
      <a-input size="large" v-model="formData[item]" type="text"
        :placeholder="`请输入${translateConditionToZhCN(item)}`" />
    </li>
  </div>
</template>

<script>
import { translateConditionToZhCN } from "../../../utils"
export default {
  name: "FeatureMatching",
  props: {
    conditionSettings: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      formData: {},
    };
  },
  methods: {
    translateConditionToZhCN
  }
};
</script>
